import {createRouter, createWebHistory } from 'vue-router';
import {getUser} from './main'
import App from "@/App";

const routes = [
    { path: '/', redirect: '/scoringtool/categories' },
    { path: '/scoringtool', redirect: '/scoringtool/categories' },
    {
        path: '/scoringtool',
        component: App,
        children: [
            {
                path: '/scoringtool/categories',
                name: 'categories',
                exact: true,
                component: () => import('./components/Categories.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            // v1
            {
                path: '/v1/scoringtool/study-information',
                name: 'v1StudyInformation',
                exact: true,
                component: () => import('./components/v1/StudyInformation.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/forms',
                name: 'v1Forms',
                exact: true,
                component: () => import('./components/v1/Forms.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/form-1',
                name: 'v1Form1',
                exact: true,
                component: () => import('./components/v1/forms/Form1.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/form-2a',
                name: 'v1Form2a',
                exact: true,
                component: () => import('./components/v1/forms/Form2a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/form-2b',
                name: 'v1Form2b',
                exact: true,
                component: () => import('./components/v1/forms/Form2b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/form-2c',
                name: 'v1Form2c',
                exact: true,
                component: () => import('./components/v1/forms/Form2c.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/form-3',
                name: 'v1Form3',
                exact: true,
                component: () => import('./components/v1/forms/Form3.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/scoring-form-1',
                name: 'v1ScoringForm1',
                exact: true,
                component: () => import('./components/v1/scorings/ScoringForm1.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/scoring-form-2a',
                name: 'v1ScoringForm2a',
                exact: true,
                component: () => import('./components/v1/scorings/ScoringForm2a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/scoring-form-2b',
                name: 'v1ScoringForm2b',
                exact: true,
                component: () => import('./components/v1/scorings/ScoringForm2b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/scoring-form-2c',
                name: 'v1ScoringForm2c',
                exact: true,
                component: () => import('./components/v1/scorings/ScoringForm2c.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v1/scoringtool/scoring-form-3',
                name: 'v1scoringForm3',
                exact: true,
                component: () => import('./components/v1/scorings/ScoringForm3.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            // v1
            // v2
            {
                path: '/v2/scoringtool/study-information',
                name: 'v2studyInformation',
                exact: true,
                component: () => import('./components/v2/StudyInformation.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/forms',
                name: 'v2Forms',
                exact: true,
                component: () => import('./components/v2/Forms.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/form-1a',
                name: 'v2Form1a',
                exact: true,
                component: () => import('./components/v2/forms/Form1a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/form-1b',
                name: 'v2Form1b',
                exact: true,
                component: () => import('./components/v2/forms/Form1b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/form-2a',
                name: 'v2Form2a',
                exact: true,
                component: () => import('./components/v2/forms/Form2a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/form-2b',
                name: '/v2Form2b',
                exact: true,
                component: () => import('./components/v2/forms/Form2b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/form-2c',
                name: 'v2Form2c',
                exact: true,
                component: () => import('./components/v2/forms/Form2c.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/form-3',
                name: 'v2Form3',
                exact: true,
                component: () => import('./components/v2/forms/Form3.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/scoring-form-1',
                name: 'v2ScoringForm1a',
                exact: true,
                component: () => import('./components/v2/scorings/ScoringForm1a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/scoring-form-1b',
                name: 'v2ScoringForm1b',
                exact: true,
                component: () => import('./components/v2/scorings/ScoringForm1b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/scoring-form-2a',
                name: 'ScoringForm2a',
                exact: true,
                component: () => import('./components/v2/scorings/ScoringForm2a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/scoring-form-2b',
                name: 'v2ScoringForm2b',
                exact: true,
                component: () => import('./components/v2/scorings/ScoringForm2b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/scoring-form-2c',
                name: 'v2ScoringForm2c',
                exact: true,
                component: () => import('./components/v2/scorings/ScoringForm2c.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/v2/scoringtool/scoring-form-3',
                name: 'v2ScoringForm3',
                exact: true,
                component: () => import('./components/v2/scorings/ScoringForm3.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            // v2
            // haematological
            {
                path: '/haematological/v1.0/scoringtool/study-information',
                name: 'haematologicalStudyInformation',
                exact: true,
                component: () => import('./components/haematological/v1.0/StudyInformation.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/forms',
                name: 'haematologicalForms',
                exact: true,
                component: () => import('./components/haematological/v1.0/Forms.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/form-1a',
                name: 'haematologicalForm1a',
                exact: true,
                component: () => import('./components/haematological/v1.0/forms/Form1a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/form-1b',
                name: 'haematologicalForm1b',
                exact: true,
                component: () => import('./components/haematological/v1.0/forms/Form1b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/form-2a',
                name: 'haematologicalForm2a',
                exact: true,
                component: () => import('./components/haematological/v1.0/forms/Form2a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/form-2b',
                name: 'haematologicalForm2b',
                exact: true,
                component: () => import('./components/haematological/v1.0/forms/Form2b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/form-2c',
                name: 'haematologicalForm2c',
                exact: true,
                component: () => import('./components/haematological/v1.0/forms/Form2c.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/form-3',
                name: 'haematologicalForm3',
                exact: true,
                component: () => import('./components/haematological/v1.0/forms/Form3.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/scoring-form-1',
                name: 'haematologicalScoringForm1a',
                exact: true,
                component: () => import('./components/haematological/v1.0/scorings/ScoringForm1a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/scoring-form-1b',
                name: 'haematologicalScoringForm1b',
                exact: true,
                component: () => import('./components/haematological/v1.0/scorings/ScoringForm1b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/scoring-form-2a',
                name: 'haematologicalScoringForm2a',
                exact: true,
                component: () => import('./components/haematological/v1.0/scorings/ScoringForm2a.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/scoring-form-2b',
                name: 'haematologicalScoringForm2b',
                exact: true,
                component: () => import('./components/haematological/v1.0/scorings/ScoringForm2b.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/scoring-form-2c',
                name: 'haematologicalScoringForm2c',
                exact: true,
                component: () => import('./components/haematological/v1.0/scorings/ScoringForm2c.vue'),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/haematological/v1.0/scoringtool/scoring-form-3',
                name: 'haematologicalScoringForm3',
                exact: true,
                component: () => import('./components/haematological/v1.0/scorings/ScoringForm3.vue'),
                meta: {
                    requiresAuth: false
                }
            }
            // haematological
        ]
    }
];

const router = createRouter({
    history: createWebHistory (),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (getUser() == null || getUser().token == null ) {
            next('/login')
            return
        }
    }
    next()
});

export default router;